import React from 'react';
import { Eye, CheckSquare, XSquare, ArrowRight } from 'lucide-react';

export const MethodologySection = () => {
  const principles = [
    { icon: CheckSquare, text: "Ce qui fonctionne déjà", highlight: false },
    { icon: XSquare, text: "Ce qui est secondaire", highlight: false },
    { icon: Eye, text: "Ce qui crée réellement une incompréhension", highlight: true },
    { icon: ArrowRight, text: "Ce qui doit être corrigé en priorité", highlight: true }
  ];

  return (
    <section className="py-32 bg-white relative">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto fade-in-section">
          <h2 className="section-title mb-12 text-center">
            Observer avant de <span className="text-accent">prescrire</span>
          </h2>

          <div className="prose prose-lg max-w-none space-y-6 mb-12">
            <p className="text-gray-700 leading-relaxed text-lg">
              Be Asset ne part pas d'une solution déjà décidée.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Le diagnostic commence par des hypothèses, puis les confronte aux priorités de l'entreprise, aux questions des prospects, aux objections rencontrées et aux signaux réellement visibles.
            </p>
            <p className="text-gray-700 leading-relaxed">
              L'objectif n'est pas de critiquer gratuitement la communication existante.
            </p>
            <p className="text-gray-700 leading-relaxed font-medium">
              L'objectif est de distinguer :
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-12">
            {principles.map((principle, index) => (
              <div 
                key={index}
                className={`flex items-center gap-3 p-5 rounded-lg border-2 ${
                  principle.highlight 
                    ? 'bg-accent/5 border-accent' 
                    : 'bg-gray-50 border-gray-200'
                }`}
              >
                <principle.icon className={`h-5 w-5 flex-shrink-0 ${
                  principle.highlight ? 'text-accent' : 'text-gray-400'
                }`} />
                <p className={`font-medium ${
                  principle.highlight ? 'text-gray-900' : 'text-gray-700'
                }`}>
                  {principle.text}
                </p>
              </div>
            ))}
          </div>

          <div className="p-8 bg-gradient-to-br from-gray-900 to-gray-800 rounded-lg text-center">
            <p className="text-xl text-white leading-relaxed font-medium">
              Une bonne recommandation ne part pas de ce qui pourrait être changé.<br />
              Elle part de ce qui <span style={{ color: '#EFF581' }}>empêche réellement</span> la valeur d'être comprise.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MethodologySection;
